export const parseChipArray = (value: any) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === 'string') return value.split(',').map((s) => s.trim());
  return [value];
};

export const estimateChipWidth = (text: string) => text.length * 8 + 32;
